import React from 'react';
import { Navigate, Route, Routes as ReactRoutes } from 'react-router-dom';

import AuthGuard from './components/AuthGuard';
import AdminLayout from './layouts/AdminLayout';
import { BuyersPage } from './pages/BuyersPage';
import { ChatsPage } from './pages/ChatsPage';
import { DashboardPage } from './pages/DashboardPage';
import { LoginPage } from './pages/LoginPage/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage/NotFoundPage';
import { OrdersPage } from './pages/OrdersPage';
import { SettingsPage } from './pages/SettingsPage';
import { SuppliersPage } from './pages/SuppliersPage';
import { UsersPage } from './pages/UsersPage';

export const Routes: React.FC = () => {
  return (
    <ReactRoutes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route
        path="/"
        element={
          <AuthGuard>
            <AdminLayout />
          </AuthGuard>
        }
      >
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="users/*" element={<UsersPage />} />
        <Route path="buyers/*" element={<BuyersPage />} />
        <Route path="chats/*" element={<ChatsPage />} />
        <Route path="suppliers/*" element={<SuppliersPage />} />
        <Route path="orders/*" element={<OrdersPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      {/* 404 route */}
      <Route path="*" element={<NotFoundPage />} />
    </ReactRoutes>
  );
};
